import { render, staticRenderFns } from "./afterSpinSoundPicker.vue?vue&type=template&id=b2561c36"
import script from "./afterSpinSoundPicker.vue?vue&type=script&lang=js"
export * from "./afterSpinSoundPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports